import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityAlert } from "../../entity/EntityAlert";

export class DtoAlertsGetRes extends EntityAlert {
  public items: EntityAlert[]  = [];
}
